import { render } from "./HelpComponent.vue?vue&type=template&id=52c03be7"
import script from "./HelpComponent.vue?vue&type=script&lang=js"
export * from "./HelpComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__